import { Box, Snackbar, Alert } from "@mui/material";
import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../../../components/Header";
import ExpensesForm from "../../../components/ExpensesForm";

const UpdateExpenses = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const { id } = useParams();
  const navigate = useNavigate();
  const [expense, setExpense] = useState(null);
  const [open, setOpen] = useState(false);
  const apiUrl = "https://oven-backend.onrender.com";

  useEffect(() => {
    const fetchExpense = async () => {
      try {
        const response = await axios.get(`${apiUrl}/expenses/${id}`);
        setExpense(response.data);
      } catch (error) {
        console.error(t("error_fetching_expense"), error);
      }
    };
    fetchExpense();
  }, [id, t]);

  const handleFormSubmit = async (values) => {
    try {
      const formattedValues = {
        ...values,
        date: values.date || new Date().toISOString(),
        amount: Number(values.amount), // تحويل إلى رقم
      };

      const response = await axios.patch(`${apiUrl}/expenses/${id}`, formattedValues);
      setOpen(true);
      setTimeout(() => {
        navigate("/expenses");
      }, 1000);
    } catch (error) {
      console.error(t("error_updating_expense"), error.response?.data || error);
    }
  };

  if (!expense) {
    return <Box m="20px">{t("loading")}</Box>;
  }

  const initialValues = {
    employee_id: expense.employee_id?._id || "",
    category: expense.category || "",
    amount: expense.amount?.toString() || "",
    description: expense.description || "",
    date: expense.date ? new Date(expense.date).toISOString().split("T")[0] : "",
    payment_status: expense.payment_status || "unpaid",
    inventory_status: expense.inventory_status || "pending",
  };


  return (
    <Box m="20px" sx={{ direction: isRTL ? "rtl" : "ltr" }}>
      <Header title={t("update_expense")} subtitle={t("update_expense_subtitle")} />
      <ExpensesForm
        initialValues={initialValues}
        handleFormSubmit={handleFormSubmit}
        buttonLabel={t("update_expense_button")}
      />
      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
        <Alert
          onClose={() => setOpen(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%", fontFamily: isRTL ? "Cairo, sans-serif" : "Roboto, sans-serif" }}
        >
          {t("success_updated_expense")}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UpdateExpenses;